module.exports = __webpack_public_path__ + "static/media/share.931a8418.svg";